import { Component, OnInit } from '@angular/core';

@Component({
    //selector: '[app-servers]',
    //selector: '.app-servers',
    selector: 'app-servers',
    template: `
        <app-server></app-server>
        <app-server></app-server>`,
    templateUrl: './servers.component.html',
    styles: [`
    .online {
        color: white;
    }`]
})
export class ServersComponent implements OnInit {

    serverStatus: string = undefined;
    allowNewServer: boolean = false;
    serverCreationStatus: string = "No server was created";
    serverName: string ="Test server"
    serverCreated: boolean = false;
    serverList: string[] = ["server 01", "server 02"];
    constructor() {

        setTimeout( () => {
            this.allowNewServer = true;
        }, 2000);

        this.serverStatus = Math.random() > 0.5 ? 'online' : 'offline';
    }

    getServerStatus(): string {
        return this.serverStatus;
    }

    getColor(): string {
        return this.getServerStatus() === 'online' ? 'green' : 'red';
    }

  ngOnInit(): void {
      // this.createNewPromise();
  }

  onCreateServer() {
      this.serverCreated = true;
      this.serverCreationStatus = "Server created!! Name is " + this.serverName;
      this.serverList.push(this.serverName);
  }

  onUpdateServerName(event: Event) {
      console.log(event);

      this.serverName = (<HTMLInputElement>event.target).value;

  }
}
